<template lang="pug" src="./../views/SobreMi.pug">
</template>

<script>
  export default {
    data() {
      return {
        datos: [
          {
            icon: 'fa fa-graduation-cap',
            msg: 'Estudiante de ingeniería en telecomunicaciones y entusiasmado por aprender las nuevas tecnologías web.',
          },
          {
            icon: 'fa fa-cog',
            msg: 'Capacidad de aprender rápido y trabajar     eficazmente en equipo. Dipuesto a escuchar a los demás y recibir críticas.',
          },
          {
            icon: 'fa fa-cloud icon-block',
            msg: 'Capaz de manejar tecnologías web tanto del lado del servidor como del cliente.',
          },
        ],
      };
    },
  };
</script>



// WEBPACK FOOTER //
// SobreMi.vue?4a486e3f